__turbopack_context__.v({
  "category-container": "search-bar-module-scss-module__lbtjpG__category-container",
  "input-container": "search-bar-module-scss-module__lbtjpG__input-container",
  "label": "search-bar-module-scss-module__lbtjpG__label",
  "notification-badge": "search-bar-module-scss-module__lbtjpG__notification-badge",
  "searchbar-container": "search-bar-module-scss-module__lbtjpG__searchbar-container",
});
